import CompLayout from "@/pcomponents/comp/layout/layout";
import ShareWordInsideArea from "@/pages/comp/plan/word/word_inside/common/share";

function WordInsideSharePage() {
  return (
    <CompLayout isConTitle={false}>
      <ShareWordInsideArea></ShareWordInsideArea>
    </CompLayout>
  );
};
export default WordInsideSharePage;